import React from "react";
import { Alert, Button, Col, Modal, Row } from "react-bootstrap";
import { BoxArrowLeft } from "react-bootstrap-icons";
import { Outlet } from "react-router-dom";
import { LayoutProps, LayoutState } from "../../types/appTypes";
import { doPost } from "../../utils/utils";
import Select from "react-select";

export default class Layout extends React.Component<LayoutProps, LayoutState> {
	constructor(props: any) {
		super(props);
		this.state = {
			showAlphaWarning: false, //For now its stable, but the component is useful for other notifications.
			showLogOutModal: false,
			integration: process.env.REACT_APP_INTEGRATION_SERVICE,
		};
	}

	hideErrorModal = () => {
		this.props.setGeneralError(false);
	};

	hideWarningModal = () => {
		this.setState({ showAlphaWarning: false });
	};

	handleLogOut = async () => {
		let url = "";
		if (this.state.integration === "GitLab") {
			url = `${this.props.integrationUrl}/api/auth/logout`;
			await doPost(url, {});
		} else {
			url = `${this.props.integrationUrl}/api/logout`;
			await doPost(url, {}, this.props.userToken);
		}
		this.props.logOut();

		this.setState({ showLogOutModal: false });
	};

	getSelectOptsFormStringArr = (arr: string[]) => {
		return arr.map(item => {
			return {
				value: item,
				label: item,
			};
		});
	};

	hideLogOutModal = () => {
		this.setState({ showLogOutModal: false });
	};

	render(): React.ReactNode {
		const user_orgs_select = this.getSelectOptsFormStringArr(this.props.corporateUserOrgs);
		const title = `Businessmap to ${this.state.integration ? this.state.integration : ""}
		${process.env.REACT_APP_INTEGRATION_VERSION ? " (" + process.env.REACT_APP_INTEGRATION_VERSION + ")" : ""} 
		integration`;
		return (
			<>
				<Row className="mt-3 mb-3">
					<Col></Col>
					<Col xs={9}>
						<div className="text-center">
							<h3>{title}</h3>
						</div>
					</Col>
					<Col className="d-flex justify-content-end">
						<Button
							className={
								!(this.props.userToken || this.props.corporateUserOrgs.length)
									? "d-none"
									: "d-flex align-items-center py-2"
							}
							variant="danger"
							onClick={() => this.setState({ showLogOutModal: true })}
						>
							<BoxArrowLeft />
						</Button>
					</Col>
				</Row>
				{/* TODO:  Handle the multiple orgs case*/}
				{!!this.props.corporateUserOrgs.length && this.props.showOrgSelect && (
					<Row className="mt-3 mb-3">
						<Col></Col>
						<Col>
							<div className="text-center">
								<Select
									required
									options={user_orgs_select}
									value={user_orgs_select.filter(item => item.value === this.props.currentUserOrg)}
									onChange={val => val && this.props.setUserOrg(val.value)}
									styles={{
										//set z-index because if we dont the header of the table in LinkTable gets over it.
										menuPortal: provided => ({ ...provided, zIndex: 9999 }),
										menu: provided => ({ ...provided, zIndex: 9999 }),
									}}
								></Select>
							</div>
						</Col>
						<Col></Col>
					</Row>
				)}

				<Modal show={!!this.state.showLogOutModal} onHide={this.hideLogOutModal}>
					<Modal.Header>Log out</Modal.Header>
					<Modal.Body>Are you sure you want to log out?</Modal.Body>
					<Modal.Footer>
						<Button variant="secondary" onClick={() => this.hideLogOutModal()}>
							Close
						</Button>
						<Button variant="danger" onClick={this.handleLogOut}>
							Log out
						</Button>
					</Modal.Footer>
				</Modal>
				<Alert
					show={this.state.showAlphaWarning}
					variant="warning"
					className="m-3"
					onClose={this.hideWarningModal}
					dismissible
				>
					<Alert.Heading> WARNING </Alert.Heading>
					<p>
						{" "}
						This is an alpha version of the integration between{" "}
						{process.env.INTEGRATION_SERVICE ? process.env.INTEGRATION_SERVICE : ""} and Businessmap if you detect any bugs
						please contact us at support@businessmap.io{" "}
					</p>
				</Alert>
				<Alert className="m-3" show={!!this.props.generalError} variant="danger" onClose={this.hideErrorModal} dismissible>
					<Alert.Heading> ERROR </Alert.Heading>
					{this.props.generalError && this.props.generalError.split(/\r?\n/).map(line => <p className="mb-0">{line}</p>)}
					{/* <p>{this.props.generalError}</p> */}
				</Alert>
				<Outlet />
			</>
		);
	}
}
